<template>
  <v-layout row justify-center>
    <v-app-bar
      app
      :color="isTranslucent ? 'transparent' : 'black'"
      :elevation="isTranslucent ? 0 : 5"
      style="z-index: 100"
    >
      <v-container no-gutters style="max-width: 1920px;">
        <v-row justify="space-between" align="center" no-gutters class="ml-lg-4 mr-lg-4">
          <v-col cols="4">
            <div @click="onLogoClicked" style="cursor: pointer">
              <img
                :src="
                  isTranslucent
                    ? require('@/assets/img/logo/logo-white-secondary-tagline.svg')
                    : require('@/assets/img/logo/logo-white_Tcolor-secondary-tagline.svg')
                "
                :class="appBarLogoClass"
              />
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.lgAndUp" cols="8">
            <v-toolbar-items class="d-flex align-center">
              <v-spacer></v-spacer>
              <template v-for="item in nav">
                <v-menu open-on-hover bottom offset-y :nudge-left="35" content-class="elevation-0" v-if="item.nested">
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-btn
                      v-bind="attrs" v-on="on"
                      to="#"
                      :title="item.title"
                      text
                      class="toolbar-btn no-hover"
                      :color="hasActiveChild(item.nested) ? '#FF5800' : 'white'"
                      style="text-transform: unset !important"
                      active-class="no-active"
                      :ripple="false"
                      >
                        <span class="poppins-normal-16px">{{ item.title }}</span>
                        <v-icon right medium :class="{ 'rotate-icon': value }">
                          mdi-chevron-down
                        </v-icon>
                    </v-btn>
                  </template>

                  <img class="menu-drop-down-before" :src="require('@/assets/img/drop-down-before.png')" />
                  <v-list class="menu-drop-down elevation-0 px-10 py-6">
                      <v-list-item v-for="subitem in item.nested">
                          <v-list-item-title>
                            <router-link :to="subitem.route" class="menu-drop-down-item poppins-normal-16px"
                                active-class="menu-drop-down-item-active"
                                v-if="!subitem.external">
                                <v-row>
                                  <v-col cols="3" class="d-flex justify-center align-center"><img :src="subitem.icon" contain max-width="20" /></v-col>
                                  <v-col>{{ subitem.title }}</v-col>
                                </v-row>
                            </router-link>
                            <a :href="subitem.route" target="_blank" style="text-decoration: none;" class="menu-drop-down-item poppins-normal-16px" v-else>
                              <v-row>
                                  <v-col cols="3" class="d-flex justify-center align-center"><img :src="subitem.icon" contain max-width="20" /></v-col>
                                  <v-col>{{ subitem.title }}</v-col>
                                </v-row>
                            </a>
                          </v-list-item-title>
                      </v-list-item>
                  </v-list>
                </v-menu>
                <v-btn
                  to="#"
                  :title="item.title"
                  text
                  class="toolbar-btn no-hover"
                  color="white"
                  style="text-transform: unset !important"
                  active-class="no-active"
                  @click="onItemClick(item)"
                  :ripple="false"
                  v-else
                  >
                    <span class="poppins-normal-16px">{{ item.title }}</span>
                  </v-btn
                >
              </template>

              <hr class="vertical-divider" />
              
              <a :href="twitter" target="_blank">
                <v-img height="16px" :src="require('@/assets/img/nav/twitter.svg')" contain class="px-3" />
              </a>
              <a :href="telegram" target="_blank">
                <v-img height="16px" :src="require('@/assets/img/nav/telegram.svg')" contain class="px-4" />
              </a>
              <a :href="discord" target="_blank">
                <v-img height="16px" :src="require('@/assets/img/nav/discord.svg')" contain class="px-4" />
              </a>

              <v-btn rounded class="button cta" dark to="/ca">
                  <span class="poppins-semi-bold-14px">
                      Contract Addresses
                  </span>
                  <v-icon right dark>mdi-arrow-right</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-col>
          <v-col v-else align="end" cols="8">
            <div
              v-if="debugbreakpoint"
              style="color: green; background: white; font-size: 20px; font-weight: 900"
            >
              {{ this.$vuetify.breakpoint.name }}
            </div>

            <v-btn icon @click="drawer = !drawer">
              <v-icon :class="{ 'spin-icon': drawer }" color="white">
                {{ drawer ? 'mdi-close' : 'mdi-menu' }}
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app fixed
      temporary
      width="100%"
      height="100%"
      style="background-color: black;">

      <div class="px-5">
        <v-list nav flat class="mt-16">
          <template v-for="(item, i) in nav">

            <v-list-group
              v-if="item.nested"
              :key="`group-${i}`"
              no-action
              color="white"
              append-icon="mdi-chevron-down"
              class="always-visible-arrow"
              :class="{'menu-drop-down-child-item-active' : hasActiveChild(item.nested)}"
            >
              <template v-slot:activator>
                <v-list-item-content class="flex-grow-0" style="overflow: visible !important; white-space: normal;">
                  <v-list-item-title class="poppins-normal-white-16px" :class="{'menu-drop-down-item-active' : hasActiveChild(item.nested)}">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(child, k) in item.nested"
                :key="`child-${k}`"
                link
                :to="!child.external ? child.route : undefined"
                :href="child.external ? child.route : undefined"
                :target="child.external ? '_blank' : undefined"
                active-class="menu-drop-down-item-active"
                class="pl-0 poppins-normal-white-14px menu-drop-down-item"
                
              >
                <v-list-item-title>
                  <v-row>
                    <v-col cols="2" class="d-flex justify-center align-center"><img :src="child.icon" contain max-width="20" /></v-col>
                    <v-col>{{ child.title }}</v-col>
                  </v-row>
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-item
              v-else
              :key="`item-${i}`"
              link
              :to="!item.external ? item.route : undefined"
              :href="item.external ? item.route : undefined"
              :target="item.external ? '_blank' : undefined"
              active-class="menu-drop-down-item-active"
            >
              <v-list-item-content>
                <v-list-item-title class="poppins-normal-white-16px">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>

        <hr class="horizontal-divider mx-2" />

        <v-row class="py-6">
          <v-col cols="4" class="justify-center align-self-center">
            <a :href="twitter" target="_blank" style="text-decoration: none;" class="poppins-semi-bold-white-16px mx-auto">
              <v-img height="20px" :src="require('@/assets/img/nav/twitter.svg')" contain />
              <div class="mt-3 d-flex align-center justify-center">Twitter</div>
            </a>
          </v-col>
          <v-col cols="4">
            <a :href="telegram" target="_blank" style="text-decoration: none;" class="poppins-semi-bold-white-16px">
              <v-img height="20px" :src="require('@/assets/img/nav/telegram.svg')" contain />
              <div class="mt-3 d-flex align-center justify-center">Telegram</div>
            </a>
          </v-col>
          <v-col cols="4">
            <a :href="discord" target="_blank" style="text-decoration: none;" class="poppins-semi-bold-white-16px">
              <v-img height="20px" :src="require('@/assets/img/nav/discord.svg')" contain />
              <div class="mt-3 d-flex align-center justify-center">Discord</div>
            </a>
          </v-col>
        </v-row>

        <hr class="horizontal-divider mx-2" />

        <div class="px-1" style="width: 100%;">
          <v-btn rounded class="button cta my-6" dark to="/ca" style="width: 100%;">
            <span class="poppins-semi-bold-14px">
                Contract Addresses
            </span>
            <v-icon right dark>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>
    </v-navigation-drawer>
    <v-snackbar vertical bottom v-model="liveSnackbar" color="#20015e" timeout="-1" style="z-index: 100;">
      <div class="poppins-bold-white-16px ms-2 mb-2">
        Injective Grant DAO Quadratic Funding voting in progress!
      </div>
      <div style="position: relative; width: 100%">
        <CountdownTimer :until="injectiveProjectReviewDateTime" style="float: left;" />
        <div style="float: right;" class="mt-3">
          <v-btn color="#ff6200" text @click="liveSnackbar = false"  style="display: inline;">
            Close
          </v-btn>
          <a href="https://dorahacks.io/injective/1/buidl" target="_blank">
            <v-btn color="#ff6200" rounded class="mx-2">
              Vote for us!
            </v-btn>
          </a>
        </div>
      </div>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapActions } from "pinia";
import { useScrollStore } from "@/stores/scroll";
import CountdownTimer from "./CountdownTimer.vue";

export default {
  name: "NavBar",
  props: ["isTranslucent", "twitter", "telegram", "discord"],
  components: { CountdownTimer },
  computed: {
    appBarLogoClass() {
      if (this.$isMobile()) {
        return "app-bar-logo-mobile";
      } else {
        return "app-bar-logo-not-mobile";
      }
    },
  },
  data() {
    let navItems = [
      {
        title: "About",
        nested: [
          {
            icon: require('@/assets/img/nav/about.svg'),
            title: "About Us",
            route: "/aboutus",
          },
          {
            icon: require('@/assets/img/nav/community.svg'),
            title: "Community",
            route: "/community",
          },
          {
            icon: require('@/assets/img/nav/platform.svg'),
            title: "Platform",
            route: "/platform",
          },
          {
            icon: require('@/assets/img/nav/roadmap.svg'),
            title: "Roadmap",
            route: "/roadmap",
          },
          {
            icon: require('@/assets/img/nav/blog.svg'),
            title: "Blog",
            route: "/blog",
          },
          {
            icon: require('@/assets/img/nav/tokenomics.svg'),
            title: "Tokenomics",
            route: "/tokenomics",
          },
          {
            icon: require('@/assets/img/nav/mediakit.svg'),
            title: "Media Kit",
            route: "https://docs.timeworx.io/other-information/media-kit",
            external: true,
          },
        ]
      },
      {
        title: "Whitepaper",
        route: "https://docs.timeworx.io",
        external: true,
      },
      {
        title: "Airdrops",
        route: "https://airdrops.timeworx.io",
        external: true,
      },
      {
        title: "Bridge",
        route: "https://bridge.timeworx.io",
        external: true,
      },
    ];
    return {
      injectiveProjectReviewDateTime: new Date(Date.UTC(2024, 3, 8, 13, 0, 0)),
      liveSnackbar: false,
      drawer: false,
      debugbreakpoint: false,
      nav: navItems,
    };
  },
  methods: {
    ...mapActions(useScrollStore, ["closeTop"]),
    onItemClick(item) {
      if (item.external) {
        window.open(item.route, "_blank");
      } else {
        window.scrollTo(0, 0);
        this.$router.push(item.route).catch((err) => {});
      }
    },
    onLogoClicked() {
      if (this.$router.history.current.path == "/") {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
        setTimeout(() => {
          this.closeTop();
        }, 500);
      } else {
        window.scrollTo(0, 0);
        this.$router.push("/").catch((err) => {});
      }
    },
    hasActiveChild(nestedItems) {
      if (!nestedItems || !Array.isArray(nestedItems)) return false;
      
      return nestedItems.some(subitem => {
        if (subitem.external) return false;
        return this.$route.path === subitem.route || 
              this.$route.path.startsWith(subitem.route + '/');
      });
    }
  },
};
</script>

<style scoped>
.app-bar-logo-mobile {
  height: 80px;
  margin-top: 10px;
  object-fit: cover;
  object-position: center; 
}

.app-bar-logo-not-mobile {
  margin-top: 5px;
  height: 100px !important;
  width: 250px;
  object-position: center; 
}

.toolbar-btn {
  outline: none;
  box-shadow: none;
}

.button {
    text-align: center;
    line-height: 20px; /* 142.857% */
    letter-spacing: 0.1px;
    background-color: #FF5800 !important;
    color: white !important;
    border-color: #FF5800 !important;
    border-radius: 100px !important;
    padding: 12px 24px !important;
}

.cta {
    text-transform: unset !important;
}

.vertical-divider {
  width: 1px;
  height: 24px;
  border-color: rgba(255, 255, 255, 0.20);
}

.horizontal-divider {
  height: 1px;
  border-color: rgba(255, 255, 255, 0.20);
}

.menu-drop-down {
  width: 270px;
  margin-top: -8px;
  border-radius: 24px;
  border: 1px solid #3B3165;
  background: black;
}

.menu-drop-down-item {
  color: #938F99 !important;
  font-weight: 400;
  text-decoration: none !important;
}

.menu-drop-down-item:hover {
  color: #FF5800 !important;
  text-shadow: -0.06ex 0 currentcolor, 0.06ex 0 currentcolor;
}

.menu-drop-down-item > div {
  transition: all 0.3s;
}

.menu-drop-down-item > div > .router-link-active {
  text-shadow: -0.06ex 0 currentcolor, 0.06ex 0 currentcolor;
  color: #FF5800 !important;
}

.menu-drop-down-item-active {
  text-shadow: -0.06ex 0 currentcolor, 0.06ex 0 currentcolor;
  color: #FF5800 !important;
}

.menu-drop-down-item:hover ::v-deep img {
  filter: invert(44%) sepia(32%) saturate(6116%) hue-rotate(359deg) brightness(98%) contrast(106%);
  scale: 1.2;
}

.menu-drop-down-item-active ::v-deep img {
  filter: invert(44%) sepia(32%) saturate(6116%) hue-rotate(359deg) brightness(98%) contrast(106%);
  scale: 1.2;
}

.menu-drop-down-before {
  width: 12px;
  height: 8px;
  margin-left: 50px;
}

.rotate-icon {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.spin-icon {
  transform: rotate(90deg); 
}

.v-icon {
  transition: transform 0.1s ease-in-out;
}

.always-visible-arrow ::v-deep .v-list-group__header__append-icon .v-icon {
    opacity: 1 !important;
    color: white;
}

.menu-drop-down-child-item-active ::v-deep .v-list-group__header__append-icon .v-icon {
    color: #FF5800;
}

.always-visible-arrow ::v-deep .v-list-group__header__append-icon {
    transition: transform 0.3s ease-in-out;
}

.no-hover::before {
  display: none !important;
}

.no-hover:hover {
  background-color: transparent !important;
}

.no-hover > span > span {
  transition: all 0.3s;
}

.no-hover:hover > span > span {
  text-shadow: -0.06ex 0 currentcolor, 0.06ex 0 currentcolor;
}
</style>
